import {
	useProspectiveClient,
} from '../hooks'

import LocaleDate from '../../LocaleDate/LocaleDate'

export default function Acquisition({id}){
	const {status,prospect} = useProspectiveClient(id)
	const acquisitionTypeText = (()=>{
		if (status!=='idle') return 
		switch(prospect.acquisition_type){
			case "message": return 'via direct message'
			case "incomplete_purchase": return 'via incomplete purchase'
			case "completed_purchase": return 'via completed purchase'
			case "form": return 'via intake form'
			case "manual": return ''
		}
	})()

	const acquisitionText = (()=>{
		if (status!=='idle') return 
		return (
			prospect.acquisition_type === 'manual'
			? 'Manually created on'
			: 'Acquired'
		)
	})()
	return (
		<div>
			<small>{acquisitionText} <LocaleDate date={new Date(prospect.date_create.split(' ').join('T'))} /> {acquisitionTypeText}</small>
		</div>
	)
}